import {AbstractModel} from './abstract-model';
import {ConsentMode} from '../types/consent-mode';

export class SiteConfigRule extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  partnerId: number | null = null;
  subid: string | null = null;
  params: any | null = null;
  accountType: string | null = null;
  advertisingPlatform: string | null = null;

  getParamValue(key: string): ConsentMode | boolean {
    return this.params[key] ?? false;
  }
}
